export const CAMPAIGN_SESSION_STORAGE_KEY = '_ah_campaign';

export const TIME_ZONE_UTC = 'UTC';

export const CURRENT_SCHOOL_TAG = 'us-schools-2026-2027';
export const CURRENT_COLLEGE_TAG = 'us-colleges-2026-2027';
export const PURCHASABLE_TAG = 'purchasable';
export const HUMAN_REVIEWED_TAG = 'human-reviewed';
export const PDF_VERIFIED_TAG = 'pdf-verified';
export const DRAFT_TAG = 'draft';
export const NEEDS_QA_TAG = 'needs-qa';
export const PARKED_TAG = 'parked';

// The tags that place an experience in a directory. A page carries exactly one,
// and which one decides whether it is a K-12 or a college listing. Anything
// keyed to "this is a directory page" tests against the whole list rather than
// CURRENT_SCHOOL_TAG, so college pages get the same treatment. Mirrors
// DIRECTORY_YEAR_TAG_TEXTS on the server.
export const DIRECTORY_YEAR_TAGS = [CURRENT_SCHOOL_TAG, CURRENT_COLLEGE_TAG];
